import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { MatDialogRef } from '@angular/material/dialog';
import {
  ComparisonObjectsWithLogicalOperators,
  CustomResult,
} from 'src/app/core/api/models';
import { Orders } from 'src/app/core/models/dynamic-table/order.model';
import { ConsoleService } from 'src/app/core/services/console.service';
import { BaseFormPageComponent } from './base-form-page.component';

@Component({
  selector: 'app-base-download-excel',
  template: ``,
  standalone: true,
})
export abstract class BaseDownloadExcelPageComponent
  extends BaseFormPageComponent
  implements OnDestroy, OnInit
{
  //#region Properties
  dynamicTabService: any;
  protected dialogRef = inject(MatDialogRef<any>);

  id: number;
  title;
  comparisonObjects: ComparisonObjectsWithLogicalOperators[] = [];
  sortObject: Orders[] = [];
  methodName: string;

  isJustCurrentOrganization;
  //#endregion

  baseDownloadExcelObserver = {
    next: (result: CustomResult) => {
      this.apiNotificationService.notifyMessage({ result });
      if (result.isSucceed) {
        this.onSuccess();
        this.onClose();
        this.dynamicTabService.setNewTab('');
        this.dynamicTabService.setNewTab('excelRequest');
        this.dynamicTabService.setActiveTab('excelRequest');
      }
    },
    error: (error) => {
      ConsoleService.error('error', error);
    },
    complete: () => (this.loading = false),
  };

  constructor() {
    super();
  }
  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', Validators.required),
      startDateTime: new FormControl(''),
      endDateTime: new FormControl(''),
    });
  }

  abstract getExcel(): void;

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  onSubmit() {
    if (this.loading) return;
    if (!this.isValidForm(this.form, this.tagName)) return;

    try {
      this.getExcel();
    } catch (error) {
      ConsoleService.error('error', error);
    }
  }
}
